/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface CreateEmployeePayData
 */
export interface CreateEmployeePayData {
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeePayData
     */
    employeeId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeePayData
     */
    jobRoleId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeePayData
     */
    payTypeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeePayData
     */
    payCode?: string | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof CreateEmployeePayData
     */
    startDate?: ShiftiePlainDate | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof CreateEmployeePayData
     */
    endDate?: ShiftiePlainDate | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeePayData
     */
    mode: CreateEmployeePayDataModeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeePayData
     */
    hourlyRate: number;
}

/**
* @export
* @enum {string}
*/
export enum CreateEmployeePayDataModeEnum {
    Fixed = 'Fixed',
    Percentage = 'Percentage'
}


/**
 * Check if a given object implements the CreateEmployeePayData interface.
 */
export function instanceOfCreateEmployeePayData(value: object): value is CreateEmployeePayData {
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined) return false;
    return true;
}

export function CreateEmployeePayDataFromJSON(json: any): CreateEmployeePayData {
    return CreateEmployeePayDataFromJSONTyped(json, false);
}

export function CreateEmployeePayDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeePayData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'jobRoleId': json['jobRoleId'] == null ? undefined : json['jobRoleId'],
        'payTypeId': json['payTypeId'] == null ? undefined : json['payTypeId'],
        'payCode': json['payCode'] == null ? undefined : json['payCode'],
        'startDate': json['startDate'] == null ? undefined : ShiftiePlainDateFromJSON(json['startDate']),
        'endDate': json['endDate'] == null ? undefined : ShiftiePlainDateFromJSON(json['endDate']),
        'mode': json['mode'],
        'hourlyRate': json['hourlyRate'],
    };
}

  export function CreateEmployeePayDataToJSON(json: any): CreateEmployeePayData {
      return CreateEmployeePayDataToJSONTyped(json, false);
  }

  export function CreateEmployeePayDataToJSONTyped(value?: CreateEmployeePayData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'jobRoleId': value['jobRoleId'],
        'payTypeId': value['payTypeId'],
        'payCode': value['payCode'],
        'startDate': ShiftiePlainDateToJSON(value['startDate']),
        'endDate': ShiftiePlainDateToJSON(value['endDate']),
        'mode': value['mode'],
        'hourlyRate': value['hourlyRate'],
    };
}

